import React from 'react';
import { TruckIcon, ShieldCheckIcon, HeadphonesIcon, CreditCardIcon } from 'lucide-react';
export function FeaturesSection() {
  return <section className="max-w-7xl mx-auto px-4" data-id="element-173" data-mp="29g8l08vp6y2j">
      <div data-id="element-174" data-mp="2n5txr1iwmh24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-175" data-mp="2n6lpu2dalwnn">
          <div className="flex items-center gap-4" data-id="element-176" data-mp="2n7wxwedrtqkk">
            <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-177" data-mp="2ieaqb0mgscvm">
              <TruckIcon className="w-6 h-6 text-primary-600" data-id="element-178" data-mp="2x2oupfzj49ea" />
            </div>
            <div data-id="element-179" data-mp="2s43uvho6vrqd">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-180" data-mp="2s4n9aoemrxzn">
                Free Shipping
              </h3>
              <p className="text-xs text-gray-500" data-id="element-181" data-mp="362u05kl5wxpt">On orders over PKR 5,000</p>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-182" data-mp="321iajf2agchm">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-183" data-mp="1broq9yjhfp21">
              <ShieldCheckIcon className="w-6 h-6 text-green-600" data-id="element-184" data-mp="17qwgn46p7i58" />
            </div>
            <div data-id="element-185" data-mp="22ghwbwz4ed5r">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-186" data-mp="22h033njes9rx">
                Genuine Products
              </h3>
              <p className="text-xs text-gray-500" data-id="element-187" data-mp="27bx7ui9nnwz0">100% authentic items</p>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-188" data-mp="2h42ynoo688cm">
            <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-189" data-mp="2h4uun0lok83f">
              <HeadphonesIcon className="w-6 h-6 text-primary-600" data-id="element-190" data-mp="2m2wevouuedgh" />
            </div>
            <div data-id="element-191" data-mp="2q3gdyxyz7r59">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-192" data-mp="2q2y8rbuc62l7">
                24/7 Support
              </h3>
              <p className="text-xs text-gray-500" data-id="element-193" data-mp="2v21d0u2hs4s4">Dedicated assistance</p>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-194" data-mp="10ptbuyzkurnw">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-195" data-mp="10r4n1jvcr1p1">
              <CreditCardIcon className="w-6 h-6 text-purple-600" data-id="element-196" data-mp="15p66w70lr51k" />
            </div>
            <div data-id="element-197" data-mp="xoqhdyc9x8hp">
              <h3 className="font-semibold text-gray-900 text-sm" data-id="element-198" data-mp="xqazuplbd0z7">
                Secure Payment
              </h3>
              <p className="text-xs text-gray-500" data-id="element-199" data-mp="tozg30p4f9yx">Multiple options</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}